export const getValidServiceNote = editorRef => {
  const content = editorRef.current?.getContent?.() || ''
  const plainText = editorRef.current?.getEditor?.()?.getText?.().trim() || ''

  const EMPTY_HTML = '<p><br></p>'
  return !plainText || content === EMPTY_HTML ? '' : content
}
